import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { STORAGE_KEYS } from "../const";

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEYS.LAST_ROUTE, location.pathname);
  }, [location.pathname]);

  return null;
}
